import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../utils/api.types";
import { fetchStockLevels, fetchStockMovements } from "./stockThunk";

interface StockSliceState {
  levels: any[];
  levelsRowCount: number;
  movements: any[];
  movementsRowCount: number;
  status: ApiStatus;
  errorMessage?: string;
}

const initialState: StockSliceState = {
  levels: [],
  levelsRowCount: 0,
  movements: [],
  movementsRowCount: 0,
  status: ApiStatus.IDLE,
  errorMessage: "",
};

// Endpoints return { data, total } (server-side paginated); tolerate a bare
// array too so the UI doesn't break if an old response shape comes back.
const readRows = (payload: any): any[] => (Array.isArray(payload) ? payload : payload?.data ?? []);
const readTotal = (payload: any): number =>
  Array.isArray(payload) ? payload.length : Number(payload?.total) || 0;

const stockSlice = createSlice({
  name: "stock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStockLevels.pending, (state) => {
        state.status = ApiStatus.LOADING;
      })
      .addCase(fetchStockLevels.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.levels = readRows(action.payload);
        state.levelsRowCount = readTotal(action.payload);
        state.errorMessage = "";
      })
      .addCase(fetchStockLevels.rejected, (state, action) => {
        state.status = ApiStatus.FAILED;
        state.errorMessage = action.error.message;
      })
      .addCase(fetchStockMovements.pending, (state) => {
        state.status = ApiStatus.LOADING;
      })
      .addCase(fetchStockMovements.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.movements = readRows(action.payload);
        state.movementsRowCount = readTotal(action.payload);
        state.errorMessage = "";
      })
      .addCase(fetchStockMovements.rejected, (state, action) => {
        state.status = ApiStatus.FAILED;
        state.errorMessage = action.error.message;
      });
  },
});

export default stockSlice.reducer;
